export const docusignConstants = {
  DOCUSIGN_SIGN_COMMITMENT_PACK_LOADING: 'DOCUSIGN_SIGN_COMMITMENT_PACK_LOADING',
  DOCUSIGN_SIGN_COMMITMENT_PACK_SUCCESS: 'DOCUSIGN_SIGN_COMMITMENT_PACK_SUCCESS',
  DOCUSIGN_SIGN_COMMITMENT_PACK_FAILURE: 'DOCUSIGN_SIGN_COMMITMENT_PACK_FAILURE'
};
